import { render } from "./support.vue?vue&type=template&id=5870a247"
import script from "./support.vue?vue&type=script&lang=js"
export * from "./support.vue?vue&type=script&lang=js"

import "./support.vue?vue&type=style&index=0&id=5870a247&lang=scss"
script.render = render

export default script